/* eslint-disable react/jsx-pascal-case */
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useSnackbar } from '../../../../providers/SnackbarProvider';
import {
  CardAllotmentOrderDto,
  CardAllotmentStatusEnum,
} from '../../../../types/card';
import { getErrorMessageFromErrorObj } from '../../../../utils/api';
import { CardAllocationService } from '../../../apis';
import CIMS_Modal, {
  IButtonGroupProps,
} from '../../../components/common/CIMS_Modal';
import { useCardOrderRequest } from '../context';

type MarkAsAcknowledgedProps = {
  isOpen: boolean;
  handleClose: () => void;
  cardAllotmentOrder?: CardAllotmentOrderDto;
};

function MarkAsAcknowledged({
  isOpen,
  handleClose,
  cardAllotmentOrder,
}: MarkAsAcknowledgedProps) {
  const { setSnackbar } = useSnackbar();
  const { listAllotmentQuery } = useCardOrderRequest();

  const buttons: IButtonGroupProps[] = [
    {
      text: 'Cancel',
      onSubmit: () => {
        handleClose();
      },
      icon: '',
      isOutline: true,
    },
    {
      text: 'Mark as Acknowledged',
      onSubmit: () => {
        CardAllocationService.updateAllocationStatus({
          cardAllotmentOrderId: cardAllotmentOrder?.id || '',
          status: CardAllotmentStatusEnum.ACCEPTED,
        })
          .then((res) => {
            setSnackbar('Successfully updated the request');
          })
          .catch((err) => {
            setSnackbar(
              getErrorMessageFromErrorObj(err, 'Error in updating status'),
              'error'
            );
          })
          .finally(() => {
            listAllotmentQuery?.refetch();
            handleClose();
          });
      },
      icon: '',
      isOutline: false,
    },
  ];
  return (
    <CIMS_Modal
      maxWidth="sm"
      open={isOpen}
      handleClose={handleClose}
      header="Mark as Acknowledged"
      buttonGroup={buttons}
    >
      <Stack sx={{ px: 3, pt: 2, pb: 6 }} spacing={1}>
        <Typography fontSize={13}>
          Are you sure you want to mark this request as acknowledged?
        </Typography>
      </Stack>
    </CIMS_Modal>
  );
}

export default MarkAsAcknowledged;
